import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const CheckCircleIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 24, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Icon"
        d="M8.83333 12L10.9444 14.1111L15.1667 9.88889M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z"
        stroke={color}
        strokeWidth="2.11111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

CheckCircleIcon.displayName = 'CheckCircleIcon'
